import React from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/es/select';
import { EAnnouncementStatus, EAnnouncementStatusText } from 'entities/Announcement/Announcement.models';

interface IComponentProps {
  onChange?: (value?: EAnnouncementStatus[]) => void;
  value?: EAnnouncementStatus[];
  placeholder?: string;
}

type AllProps = SelectProps<any> & IComponentProps;

export class AnnouncementStatusSelector extends React.PureComponent<AllProps> {
  handleChange = (value: EAnnouncementStatus[]) => {
    const { onChange } = this.props;
    onChange && onChange(value);
  };

  render() {
    const { value, placeholder } = this.props;
    return (
      <Select
        allowClear
        mode="multiple"
        className="width-full"
        placeholder={placeholder}
        value={value}
        defaultActiveFirstOption={false}
        onChange={(value) => this.handleChange(value)}
      >
        <Select.Option
          key={EAnnouncementStatus.Active}
          value={EAnnouncementStatus.Active}
          label={EAnnouncementStatusText.Active}
        >
          {EAnnouncementStatusText.Active}
        </Select.Option>
        <Select.Option
          key={EAnnouncementStatus.Pending}
          value={EAnnouncementStatus.Pending}
          label={EAnnouncementStatusText.Pending}
        >
          {EAnnouncementStatusText.Pending}
        </Select.Option>
        <Select.Option
          key={EAnnouncementStatus.Expired}
          value={EAnnouncementStatus.Expired}
          label={EAnnouncementStatusText.Expired}
        >
          {EAnnouncementStatusText.Expired}
        </Select.Option>
      </Select>
    );
  }
}
